import {IBannerAd} from './types';
import ReactDOM from 'react-dom';
import parse from 'html-react-parser';

export const renderAds = (isMobile: Boolean, bannerInfo: IBannerAd | null) => {

  let headerTag: string | undefined | null = null;
  let bodyTag: string | undefined | null= null;

  if (isMobile) {
    headerTag = bannerInfo?.bannerHeaderMobile;
    bodyTag = bannerInfo?.bannerBodyMobile;
  } else {
    headerTag = bannerInfo?.bannerHeader;
    bodyTag = bannerInfo?.bannerBody;
  }


  if (headerTag) {
    const element: any = parse(headerTag, {
      replace: function (domNode: any) {
        if (domNode.type === 'script') {
          const script = document.createElement('script');

          if ("async" in domNode.attribs) {
            script.async = true;
          }
          if (domNode.attribs.src) {
            script.src = domNode.attribs.src;
          }

          if (domNode.children.length > 0) {
            script.innerText = domNode.children[0].data;
          }

          document.head.appendChild(script);

        }
      }
    });

    const elementId = 'header-' + bannerInfo?.widgetBuilderComponentId.toString();
    if (elementId) {
      ReactDOM.render(element, document.getElementById(elementId));
    }
  }

  if (bodyTag) {
    const bodyEle: any = parse(bodyTag, {
      replace: function (domNode: any) {

        if (domNode.type === 'script') {
          const script = document.createElement('script');

          if ("async" in domNode.attribs) {
            script.async = true;
          }
          if (domNode.attribs.src) {
            script.src = domNode.attribs.src;
          }
          //if the script tag has text between the script tags
          if (domNode.children.length > 0) {
            script.innerText = domNode.children[0].data;
          }
          const elementId = 'body-' + bannerInfo?.widgetBuilderComponentId.toString();
          const theEle = document.getElementById(elementId);

          if (theEle !== null) {
            theEle.appendChild(script);
          }

        }
      }
    });

    const elementId = 'body-' + bannerInfo?.widgetBuilderComponentId.toString();
    if (elementId) {
      ReactDOM.render(bodyEle, document.getElementById(elementId));
    }
  }
}
